(function () {
  const modalId = 'md-app-embed__modal';
  const closeSelector = '.md-modal-closeButtonAction';
  const dismissCookieName = 'mdApp_cookieModalTime';
  const dismissMaxAge = 7 * 24 * 60 * 60;
  const countryButtonId = 'md-form__select__country';
  const countryListId = 'orbeCountryList';
  const countrySearchId = 'orbe-country-search';
  const countrySearchWrapperClass = 'orbe-country-search';
  const noResultsClass = 'orbe-country-search__empty';
  const searchStyleId = 'orbe-country-search-style';
  const swedishModalCopy = {
    title: 'Är du på rätt plats?',
    text: 'Välj ditt leveransland.',
    helper: 'Handla från rätt land så att priser, leverans och kassa stämmer. Vi kan bara skicka din order till adresser i valt land.',
    cta: 'Fortsätt',
    search: 'Sök land',
    empty: 'Inga länder hittades',
  };

  function getModal() {
    return document.getElementById(modalId);
  }

  function isSwedishLocale() {
    return document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('sv') === 0;
  }

  function translateSwedishModalCopy() {
    const modal = getModal();
    if (!modal || !isSwedishLocale()) return;

    const title = modal.querySelector('.md-modal__title, [class*="modal__title"], h2');
    const paragraphs = modal.querySelectorAll('p');
    const cta = Array.from(modal.querySelectorAll('button')).find((button) =>
      button.textContent.trim().toLowerCase() === 'continue'
    );

    if (title) title.textContent = swedishModalCopy.title;
    if (paragraphs[0]) paragraphs[0].textContent = swedishModalCopy.text;
    if (paragraphs[1]) paragraphs[1].textContent = swedishModalCopy.helper;
    if (cta) cta.textContent = swedishModalCopy.cta;
  }

  function setDismissCookie() {
    let cookie = `${dismissCookieName}=true; path=/; max-age=${dismissMaxAge}; SameSite=Lax`;
    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }
    document.cookie = cookie;
  }

  function hideModalImmediately() {
    const modal = getModal();
    if (!modal) return;

    setDismissCookie();

    if (typeof window.mdApp_closeModal === 'function') {
      try {
        window.mdApp_closeModal(modalId);
      } catch (error) {
        // Fall back to the direct class updates below.
      }
    }

    modal.classList.remove('orbe--opening', 'orbe--closing', 'orbe--preparing');
    modal.classList.add('orbe--hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('orbe--opened');

    if (modal.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }

  function shouldDismiss(event) {
    const target = event.target;
    if (!(target instanceof Element)) return false;

    const closeButton = target.closest(closeSelector);
    if (closeButton) return true;

    const modal = getModal();
    if (!modal || modal.classList.contains('orbe--hidden')) return false;

    return target === modal || target.classList.contains('md-modal__container');
  }

  function onDismissIntent(event) {
    if (!shouldDismiss(event)) return;

    hideModalImmediately();

    if (event.type === 'click') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function getCountryList() {
    return document.getElementById(countryListId);
  }

  function getCountryButton() {
    return document.getElementById(countryButtonId);
  }

  function getCountryItems(list) {
    if (!list) return [];

    return Array.from(list.querySelectorAll('li[id^="orbe-country-"]')).filter((item) =>
      item.querySelector('.md-form__select__country__list-link')
    );
  }

  function getCountrySearchInput() {
    return document.getElementById(countrySearchId);
  }

  function getNoResultsItem(list) {
    return list ? list.querySelector(`.${noResultsClass}`) : null;
  }

  function injectCountrySearchStyles() {
    if (document.getElementById(searchStyleId)) return;

    const style = document.createElement('style');
    style.id = searchStyleId;
    style.textContent = `
      #${modalId} .${countrySearchWrapperClass} {
        margin: 0.75rem 0 0.5rem;
      }

      #${modalId} .${countrySearchWrapperClass}[hidden] {
        display: none !important;
      }

      #${modalId} .${countrySearchWrapperClass}__input {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #ed005d;
        border-radius: 4px;
        background: #fff;
        color: inherit;
        font: inherit;
        padding: 12px 14px;
        outline: none;
      }

      #${modalId} .${countrySearchWrapperClass}__input:focus {
        border-color: #ed005d;
        box-shadow: 0 0 0 2px rgba(237, 0, 93, 0.12);
      }

      #${modalId} .${noResultsClass} {
        display: none;
        padding: 12px 14px;
        color: #6b7280;
        background: #fff;
        cursor: default;
      }

      #${modalId} .${noResultsClass}.is-visible {
        display: list-item;
      }
    `;
    document.head.appendChild(style);
  }

  function applyCountryFilter(list, query) {
    const normalizedQuery = normalizeSearchValue(query);
    const noResultsItem = getNoResultsItem(list);
    let visibleCount = 0;

    getCountryItems(list).forEach((item) => {
      const option = item.querySelector('.md-form__select__country__list-link');
      const searchableText = normalizeSearchValue([
        item.dataset.name,
        item.dataset.country,
        option ? option.dataset.countryname : '',
        option ? option.dataset.country : '',
        item.textContent,
      ].join(' '));
      const shouldShow = !normalizedQuery || searchableText.includes(normalizedQuery);

      item.style.display = shouldShow ? 'list-item' : 'none';
      if (shouldShow) visibleCount += 1;
    });

    if (noResultsItem) {
      const hasNoResults = normalizedQuery && visibleCount === 0;
      noResultsItem.classList.toggle('is-visible', Boolean(hasNoResults));
      noResultsItem.hidden = !hasNoResults;
    }

    return visibleCount;
  }

  function restoreCountryList() {
    const list = getCountryList();
    const input = getCountrySearchInput();
    if (!list) return;

    if (input) input.value = '';

    getCountryItems(list).forEach((item) => {
      item.style.display = 'list-item';
    });

    const noResultsItem = getNoResultsItem(list);
    if (noResultsItem) {
      noResultsItem.classList.remove('is-visible');
      noResultsItem.hidden = true;
    }
  }

  function updateCountrySearchVisibility(shouldFocus) {
    const modal = getModal();
    const list = getCountryList();
    const input = getCountrySearchInput();
    const wrapper = input ? input.closest(`.${countrySearchWrapperClass}`) : null;
    if (!modal || !list || !wrapper) return;

    const isOpen = !modal.classList.contains('orbe--hidden') && !list.hidden;
    wrapper.hidden = !isOpen;

    if (!isOpen) {
      restoreCountryList();
      return;
    }

    if (shouldFocus && input) {
      window.requestAnimationFrame(() => {
        input.focus({ preventScroll: true });
      });
    }
  }

  function setupCountrySearch() {
    const list = getCountryList();
    const button = getCountryButton();
    if (getCountrySearchInput()) return true;
    if (!list || !button) return false;

    injectCountrySearchStyles();

    const wrapper = document.createElement('div');
    wrapper.className = countrySearchWrapperClass;
    wrapper.hidden = true;

    const input = document.createElement('input');
    input.id = countrySearchId;
    input.className = `${countrySearchWrapperClass}__input`;
    input.type = 'search';
    input.placeholder = isSwedishLocale() ? swedishModalCopy.search : 'Search country';
    input.autocomplete = 'off';
    input.autocapitalize = 'none';
    input.spellcheck = false;
    input.setAttribute('aria-label', 'Search country');

    wrapper.appendChild(input);
    list.parentNode.insertBefore(wrapper, list);

    const noResultsItem = document.createElement('li');
    noResultsItem.className = noResultsClass;
    noResultsItem.hidden = true;
    noResultsItem.setAttribute('role', 'presentation');
    noResultsItem.textContent = isSwedishLocale() ? swedishModalCopy.empty : 'No countries found';
    list.appendChild(noResultsItem);

    input.addEventListener('input', () => {
      applyCountryFilter(list, input.value);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;

      const visibleItems = getCountryItems(list).filter((item) => item.style.display !== 'none');
      if (visibleItems.length !== 1) return;

      const option = visibleItems[0].querySelector('.md-form__select__country__list-link');
      if (!option) return;

      event.preventDefault();
      option.click();
      window.setTimeout(() => {
        restoreCountryList();
        updateCountrySearchVisibility(false);
      }, 0);
    });

    button.addEventListener('click', () => {
      window.setTimeout(() => updateCountrySearchVisibility(true), 0);
      window.setTimeout(() => updateCountrySearchVisibility(true), 100);
    });

    list.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.md-form__select__country__list-link')) return;

      window.setTimeout(() => {
        restoreCountryList();
        updateCountrySearchVisibility(false);
      }, 0);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (button.contains(target) || list.contains(target) || wrapper.contains(target)) return;

      window.setTimeout(() => updateCountrySearchVisibility(false), 0);
    }, true);

    return true;
  }

  function initCountrySearch() {
    translateSwedishModalCopy();
    return setupCountrySearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountrySearch, { once: true });
  } else {
    initCountrySearch();
  }

  const observerTarget = document.body || document.documentElement;
  if (observerTarget && !getCountrySearchInput()) {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      window.requestAnimationFrame(() => {
        scheduled = false;
        if (initCountrySearch()) {
          observer.disconnect();
        }
      });
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  }

  document.addEventListener('pointerdown', onDismissIntent, true);
  document.addEventListener('click', onDismissIntent, true);
})();
